/** Platform-board geometry + selection/scroll math. Pure, unit-tested.
 *  Mirrors ShopScene's tuned layout so the ~57px single-jump arc clears
 *  exactly one row. Returns VISIBLE row indices; callers add scrollOffset. */
import { NATIVE_WIDTH } from "../../config";

export const STACK_TOP_Y = 42;
export const ROW_HEIGHT = 44;
export const PLATFORM_HEIGHT = 4;
export const CARD_STACK_WIDTH = 200;
export const CARD_STACK_X = Math.round((NATIVE_WIDTH - CARD_STACK_WIDTH) / 2);
/** Card body height — kept in sync with ui/OfferCard CARD_HEIGHT (36). */
export const CARD_BODY_HEIGHT = 36;

/** Y of the top of row i's card. */
export function rowTopY(i: number): number {
  return STACK_TOP_Y + i * ROW_HEIGHT;
}

/** Y of the top surface of the platform under row i. */
export function platformTopY(i: number, cardHeight = CARD_BODY_HEIGHT): number {
  return rowTopY(i) + cardHeight + 4;
}

/**
 * Which visible row the hero stands on, or -1. `heroBottomY` is the physics
 * body bottom; `heroX` the sprite x. The grounded check stays in the scene.
 */
export function selectedRow(
  heroBottomY: number,
  heroX: number,
  visibleRows: number,
  opts: { cardHeight?: number; tolerance?: number } = {},
): number {
  const cardHeight = opts.cardHeight ?? CARD_BODY_HEIGHT;
  const tol = opts.tolerance ?? 4;
  const left = CARD_STACK_X - 2;
  const right = CARD_STACK_X + CARD_STACK_WIDTH + 2;
  if (heroX < left || heroX > right) return -1;
  for (let i = 0; i < visibleRows; i++) {
    if (Math.abs(heroBottomY - platformTopY(i, cardHeight)) < tol) return i;
  }
  return -1;
}

export function clampScrollOffset(offset: number, total: number, visible: number): number {
  const max = Math.max(0, total - visible);
  return Math.min(Math.max(0, offset), max);
}
